module.exports = __webpack_public_path__ + "img/thumbnail_Llama_j_normal.ea9cab33.png";